import { ILookup } from './lookup';

export class AndOrOperatorOptions implements ILookup<string> {
  id: string;
  description: string;

  static and: AndOrOperatorOptions = { id: 'And', description: 'And' };
  static or: AndOrOperatorOptions = { id: 'Or', description: 'Or' };

  static get options(): ILookup<string>[] {
    return [ 
      AndOrOperatorOptions.and,
      AndOrOperatorOptions.or
    ];
  }
}